import { useRef, useState } from "react";
import request from "../../../../../utils/request";
import toast from "react-hot-toast";

const MedicalXrayForm = ({
  investigations,
  radiologyReportData,
  setRadiologyReportData,
  setStatusValue,
  statusValue,
}) => {
  const detailsRef = useRef(null);

  // state
  const [searchingId, setSearchingId] = useState(null);

  const [invTestsData, setInvTestsData] = useState([]);

  const fetchInvTestData = async (e, invTest) => {
    const dataToSend = {
      test_id: invTest?.id,
      info_value: e.target.value.trim(),
    };
    if (dataToSend.test_id) {
      const response = await request.create(
        `reports/investigation-tests-data`,
        dataToSend
      );
      if (response) {
        setInvTestsData(response);
      }
    }
  };

  const handleOnChange = (event, index) => {
    // const updatedInvestigations = { ...investigations };

    // if (updatedInvestigations.investigation_tests) {
    //   updatedInvestigations.investigation_tests[index] = {
    //     ...updatedInvestigations.investigation_tests[index],
    //     info_value: event.target.value.trim(),
    //   };
    // }

    // Create a new array with updated info_values and test_ids
    // const updatedSuggestionData = updatedInvestigations.investigation_tests.map(
    //   (item, i) => ({
    //     test_id: item?.id,
    //     info_value: i === index ? event.target.value.trim() : item?.info_value,
    //   })
    // );

    // setSuggestionData(updatedSuggestionData);

    // setInputValue(event.target.value);

    setRadiologyReportData((previousReport) => {
      const updatedReport = [...previousReport];
      updatedReport[index] = {
        ...updatedReport[index],
        result: event.target.value,
      };
      return updatedReport;
    });

    // setSearchingId(index);
    // fetchInvTestData(event);
  };

  const handleSuggestionSelect = (value, index) => {
    setRadiologyReportData((previousReport) => {
      previousReport[index].result = value;
      return [...previousReport];
    });

    setSearchingId(null);
  };

  const handleCopy = (index, investigation) => {
    const selectedValue = radiologyReportData[index]?.result?.replace(
      /(<([^>]+)>)/gi,
      ""
    );

    setRadiologyReportData((previousReport) => {
      previousReport[previousReport.length - 1].result = selectedValue;
      return [...previousReport];
    });
  };

  return (
    <div>
      <div className="bg-orange d-flex flex-column justify-content-between rounded-1 text-white position-relative w-100">
        <div className="d-flex p-3 flex-column" style={{ gap: "16px" }}>
          {investigations?.investigation_tests?.map((investigation, index) => {
            const matchedReport = radiologyReportData.find(
              (report) => report.test_id === investigation?.id
            );
            //   console.log(matchedReport);
            return (
              <div key={index}>
                <div
                  className="d-flex flex-column align-items-start position-relative"
                  style={{ rowGap: "16px" }}
                >
                  <label
                    htmlFor={`${investigation?.name?.toLowerCase()}`}
                    className="w-25 fs-6 fw-bold text-dark"
                  >
                    {investigation?.name}
                  </label>
                  <div className="input-group w-100">
                    <input
                      type="text"
                      name="info"
                      autoComplete="off"
                      id={`${investigation?.name?.toLowerCase()}`}
                      value={matchedReport?.result || ""}
                      onChange={(event) => {
                        handleOnChange(event, index);
                        fetchInvTestData(event, investigation);
                        setSearchingId(index);
                        //   fetchFindings(event, investigation);
                      }}
                      className={`form-control w-75 fw-bold ${
                        investigation?.name === "Findings" &&
                        matchedReport?.result === "Normal CXR"
                          ? "text-success"
                          : "text-primary"
                      }`}
                      required
                    />

                    <span
                      className="input-group-text"
                      id="addon-wrapping"
                      style={{ width: "3rem", height: "3.4rem" }}
                      onClick={() => handleCopy(index, investigation)}
                    >
                      <i
                        className="fa-regular fa-copy px-1"
                        style={{
                          fontSize: "1.5rem",
                          cursor: "pointer",
                        }}
                      ></i>
                    </span>
                  </div>
                  {searchingId === index && invTestsData?.length > 0 && (
                    <div
                      className="position-absolute border-bottom top-100 bg-light text-dark w-100 z-10"
                      style={{
                        zIndex: "100",
                        left: "0%",
                        overflowY: "scroll",
                        maxHeight: "410px",
                        width: "100%",
                      }}
                      ref={detailsRef}
                    >
                      {invTestsData?.map((item) => (
                        <div
                          className="search-row"
                          onClick={(event) =>
                            handleSuggestionSelect(item?.info, index)
                          }
                          style={{
                            padding: "2px 12px",
                            cursor: "pointer",
                            width: "100%",
                            color: "#000",
                            fontWeight: "bold",
                            fontSize: "16px",
                          }}
                        >
                          {item?.info}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
          <div
            className="d-flex flex-column align-items-start"
            style={{ rowGap: "16px" }}
          >
            <label
              htmlFor="risk-factor"
              className="w-25 fs-6 fw-bold text-dark"
            >
              Status
            </label>
            <select
              name="dropdown"
              className="form-select w-100 fw-bold"
              id="risk-factor"
              onChange={(event) => setStatusValue(Number(event.target.value))}
              defaultValue={statusValue}
              required
              value={statusValue}
            >
              <option value={1} className="fw-bold">
                Select Status
              </option>
              <option value={2} className="fw-bold">
                FIT
              </option>
              <option value={3} className="fw-bold">
                UNFIT
              </option>
              <option value={4} className="fw-bold">
                HELDUP
              </option>
            </select>
          </div>
        </div>
      </div>
      {/* <div className="py-1 mt-2 rounded-bottom d-flex justify-content-between gap-4">
          <button
            className="btn btn-success px-2 btn-sm fs-6 w-100"
            onClick={saveFilm}
          >
            Save Film
          </button>
        </div> */}
      <div className="py-0 mt-2 rounded-bottom w-100">
        {/* <button
            className="btn btn-sm btn-warning w-100"
            data-bs-toggle="modal"
            data-bs-target={`#restoreXray`}
          >
            Make Status Processing
          </button> */}
      </div>
    </div>
  );
};

export default MedicalXrayForm;
